module.exports = __webpack_public_path__ + "assets/a3572bc83db5d2757762d4bb12746f04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/ro/1.png
// module id = 350
// module chunks = 1